<div class="hosts layout-spacing" data-testid="hosts">
    <!-- Content to be projected into the sub-navbar component -->
    <ng-template #subNavBarContent>
        <div class="nav-bar__container" data-testid="nav-bar-container">
            <ntv-button
                size="xl"
                rounded="md"
                [variant]="'accent'"
                class="nav-bar__btn"
                (buttonClick)="onAddHostPlace()">
                <div class="main-btn" data-testid="add-host-place-btn">
                    <span>Add Host Place</span>
                    <svg width="14" height="14">
                        <use [attr.href]="spritePath + '#' + icons.mapFolded"></use>
                    </svg>
                </div>
            </ntv-button>

            <ntv-button
                size="xl"
                rounded="md"
                [variant]="'accent'"
                class="nav-bar__btn"
                (buttonClick)="toggleAnalytics()"
                data-testid="show-analytics-btn">
                <div class="main-btn" data-testid="show-analytics-inner-btn">
                    <svg width="14" height="14">
                        <use [attr.href]="spritePath + '#' + icons.reports"></use>
                    </svg>
                    <span>{{ showAnalytics() ? 'Hide Analytics' : 'Show Analytics' }}</span>
                    <svg
                        class="nav-bar__btn-chevron"
                        [class.nav-bar__btn-chevron--open]="showAnalytics()"
                        width="12"
                        height="12">
                        <use [attr.href]="spritePath + '#' + icons.chevronDown"></use>
                    </svg>
                </div>
            </ntv-button>
        </div>
    </ng-template>

    <div class="hosts__stats" data-testid="hosts-stats">
        @for (host of statsData(); track host.title + $index) {
            <app-stats-card [statsData]="host" [hasTotal]="true" width="100%"></app-stats-card>
        }
    </div>

    <!-- Analytics Panel -->
    <div
        class="hosts__analytics"
        [class.hosts__analytics--visible]="showAnalytics()"
        data-testid="hosts-analytics-panel">
        <div class="hosts__analytics-inner" data-testid="hosts-analytics-inner-div">
            <!-- Host Analytics Graph -->
            <div class="hosts__analytics-graph" data-testid="hosts-analytics-graph-wrapper">
                @if (isChartLoading() || !analyticsLoaded()) {
                    <ntv-card variant="elevated" data-testid="hosts-analytics-card">
                        <div
                            class="analytics-graph-skeleton"
                            data-testid="hosts-analytics-skeleton">
                            <ntv-skeleton width="100%" height="400px" borderRadius="12px" />
                        </div>
                    </ntv-card>
                } @else {
                    <ntv-graph
                        [config]="hostGraphConfig()"
                        (filterChange)="onGraphFilterChange($event)"
                        data-testid="hosts-analytics-graph"></ntv-graph>
                }
            </div>

            <!-- Top Hosts Card -->
            <ntv-card variant="elevated" class="hosts__analytics-top">
                <div class="top-hosts" data-testid="top-hosts">
                    <div class="top-hosts__header" data-testid="hosts-top-hosts-header-div">
                        @if (isTopHostsLoading() || !analyticsLoaded()) {
                            <ntv-skeleton width="32px" height="32px" borderRadius="6px" />
                            <div class="flex flex-col gap-1" data-testid="hosts-flex-div-4">
                                <ntv-skeleton width="120px" height="18px" borderRadius="4px" />
                                <ntv-skeleton width="160px" height="14px" borderRadius="4px" />
                            </div>
                        } @else {
                            <div
                                class="top-hosts__icon-box"
                                data-testid="hosts-top-hosts-icon-box-div">
                                <svg width="14" height="14">
                                    <use [attr.href]="spritePath + '#' + icons.mapFolded"></use>
                                </svg>
                            </div>
                            <div>
                                <h3 class="top-hosts__title">Top Host(s)</h3>
                                <p class="top-hosts__subtitle">Ranked by total license count</p>
                            </div>
                        }
                    </div>
                    @if (isTopHostsLoading() || !analyticsLoaded()) {
                        <div class="top-hosts__skeleton" data-testid="top-hosts-skeleton">
                            <ntv-skeleton width="100%" height="300px" borderRadius="12px" />
                        </div>
                    } @else if (topHostsData().length === 0) {
                        <p class="top-hosts__empty" data-testid="top-hosts-empty">
                            No host data available.
                        </p>
                    } @else {
                        <ul class="top-hosts__list" data-testid="top-hosts-list">
                            @for (host of topHostsData(); track host.rank) {
                                <li class="top-hosts__item">
                                    <span
                                        class="top-hosts__name"
                                        data-testid="hosts-top-hosts-name-span"
                                        >{{ host.rank }}. {{ host.name }}</span
                                    >
                                    <span
                                        class="top-hosts__count"
                                        data-testid="hosts-top-hosts-count-span">
                                        <strong class="top-hosts__count-number">{{
                                            host.licenses
                                        }}</strong>
                                        <span
                                            class="top-hosts__count-label"
                                            data-testid="hosts-top-hosts-count-label-span"
                                            >License(s)</span
                                        >
                                    </span>
                                </li>
                            }
                        </ul>
                    }
                </div>
            </ntv-card>
        </div>
    </div>
    <div class="hosts__table" data-testid="hosts-table">
        <div class="hosts__table-header" data-testid="hosts-table-header">
            <app-table-toolbar
                [placeholder]="'Search Host Name, Address, City, Postal Code, DMA Name or #Tag '"
                [buttons]="toolbarButtons()"
                [additionalChips]="timezoneChips()"
                (actionClick)="onToolbarAction($event)"
                (searchValueChange)="onSearch($event)">
                <ntv-dropdown
                    leftActions
                    [config]="timezoneConfig()"
                    (selectionChange)="onTimezoneChange($event)"></ntv-dropdown>

                <!-- <ntv-date-range-picker leftActions variant="single"></ntv-date-range-picker> -->
            </app-table-toolbar>
        </div>
        <div class="hosts__table-body" data-testid="hosts-table-body">
            <div
                class="hosts__content-table main-table-container"
                data-testid="hosts-content-table">
                <app-table
                    [columns]="hostsColumns"
                    [data]="hostsData()"
                    [totalDataLength]="totalCount()"
                    [loading]="isLoading()"
                    [tableTitle]="'Hosts'"
                    [tableHeight]="'780px'"
                    [hasCheckBox]="true"
                    [paddingY]="'14px'"
                    [paddingX]="'15px'"
                    (actionClick)="onActionClick($event)"
                    (cellClick)="onCellClick($event)"
                    (showMoreRequested)="onShowMore()"
                    (selectionChange)="onSelectionChange($event)">
                    <ng-template ntvTableCell="dealerName" let-value let-row="row">
                        @if (value === 'none for now') {
                            <span>{{ truncateText(value) }}</span>
                        } @else {
                            <span
                                class="table__clickable-cell"
                                (click)="
                                    onCellClick({ field: 'dealerName', value: value, row: row })
                                "
                                data-testid="hosts-table-clickable-cell-span">
                                {{ truncateText(value) }}
                            </span>
                        }
                    </ng-template>
                </app-table>
            </div>
        </div>
    </div>
</div>
